export default class Popup {
    constructor() {
        this.backdrop = 'static';
    }
    open(data) {
        this.hide();
        this.$scope = this.$rootScope.$new(true);
        Object.assign(this.$scope, data);
        const modalOptions = {
            id: 'popup',
            scope: this.$scope,
            backdrop: this.backdrop,
            contentTemplate: this.contentTemplateUrl,
        };
        if (this.templateUrl) {
            modalOptions.templateUrl = this.templateUrl;
        }
        this.modal = this.$modal(modalOptions);
    }
    isOpen() {
        return this.modal && this.modal.$isShown;
    }
    hide() {
        if (this.modal)
            this.modal.hide();
    }
}
